import { useContext } from 'react';

import { PageLayoutStateContext } from '../contexts/PageLayoutContext';

/**
 * [ 어떠한 레이아웃에 위치한 컴포넌트인지 정보를 전달하는 hook ]
 *
 * - 어떠한 레이아웃인지에 따라 별도의 처리가 필요한 상황을 대응해야할 때 사용합니다.
 *
 * @example
 *
 * // list, detail, form, panel
 * const { layoutType } = usePageLayoutState();
 */
export default function usePageLayoutState() {
  return useContext(PageLayoutStateContext);
}
